module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"placeholder":{"firstName":"Jan","lastName":"de Vries","phone":"06 12345678","email":"naam@voorbeeld.nl"}}}')
  delete Component.options._Ctor
}
